import { jsx, jsxs } from "react/jsx-runtime";
import { Circle, Square, XStack } from "tamagui";
function ShapesDemo() {
  return /* @__PURE__ */ jsxs(XStack, { padding: "$2", space: "$4", children: [
    /* @__PURE__ */ jsx(Square, { size: 100, backgroundColor: "$color", elevation: "$4" }),
    /* @__PURE__ */ jsx(Circle, { size: 100, backgroundColor: "$color", elevation: "$4" })
  ] });
}
export {
  ShapesDemo
};
//# sourceMappingURL=ShapesDemo.js.map
